export default __webpack_public_path__ + "static/media/Cow in Mysore.b9165889.jpg";